import React, { useEffect,useState } from "react";
import { Button, Empty, Pagination } from "antd";
import { useNavigate } from "react-router-dom";

import useStatsStore from "../../store/stats.store";

import "./myInternalTask.scss";
import TeamAssignmentCard from "../TeamAssignmentCard";
import Filter from "../filter";

export default function MyInternalTaskUpdates(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  }; 

  const { myInternalConsolidatedStats,getMyInternalConsolidatedStats,myInternalConsolidatedCount } = useStatsStore();
  useEffect(() => {

  }, []);

  return (
    <div className="teamTask-wrapper">
      <div className="teamTask-title"> ({myInternalConsolidatedCount || 0}) JDs Found</div>
      <Filter
        filtername = {"getMyInternalConsolidatedStats"}
        initDuration={"24"}
        initPrio={"All"}
        initResume={"All"}
        initJDStatus={"Active"}    
        initClient={"All"}        
        enableDuration
        enableResumes
        enablePriority
        enableJdStatus
        enableCustomers    
        enableTAs  
        handleFilter={getMyInternalConsolidatedStats}
        pageNo={currentPage}
        pageSize={pageSize}
        pageHandler = {setCurrentPage}  
      />      
      <div></div>       
      {myInternalConsolidatedStats?.JDListInternalActivity?.length > 0 ? (
      <>
              {myInternalConsolidatedStats?.JDListInternalActivity?.map((jd,idx) => (
                    <TeamAssignmentCard data={jd} all={false} index= {idx+1+ (currentPage-1)*pageSize}/>
              ))}
      </>
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
       <Pagination
              style={{ marginTop: "4px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={myInternalConsolidatedCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
        />       
    </div>
  );
}
